'use client';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToMarketingSection } from '@/components/marketing/site/marketing-nav-link';

export function MarketingHashScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (pathname !== '/' || !hash) return;

    const sectionId = hash.replace('#', '');
    if (!sectionId) return;

    let frame = 0;
    let attempts = 0;

    const tryScroll = () => {
      if (scrollToMarketingSection(sectionId, 'auto')) return;
      if (attempts >= 80) return;
      attempts += 1;
      frame = window.requestAnimationFrame(tryScroll);
    };

    frame = window.requestAnimationFrame(tryScroll);

    return () => {
      window.cancelAnimationFrame(frame);
    };
  }, [pathname, hash]);

  return null;
}
